/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Regular expressions to validate emails.
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export abstract class EmailRegex {
    /**
     * Represents a HTML5 Validation Regex.
     *
     * A valid email address is a string that matches the email production of the following ABNF, the character set for which is Unicode.
     * This ABNF implements the extensions described in RFC 1123.
     *
     * For more info: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address.
     */
    // eslint-disable-next-line security/detect-unsafe-regex
    public static readonly html5EmailRegex = /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

    /**
     * Returns a default regex which should be used for most email validation cases.
     *
     * As of now, the default regex is HTML5 email regex standard.
     * @see EmailRegex.html5EmailRegex - The regex which is set to be default right now.
     *
     * @returns Regular expression for email validation.
     */
    public static get defaultRegex(): RegExp {
        return EmailRegex.html5EmailRegex;
    }
}
